export function SaveActions({
  styles,
  topupOpen,
  topupValue,
  setTopupValue,
  openTopup,
  submitTopup,
  showSaveFinalAction,
  saveJustDone,
  saveBusy,
  onFinish,
  onCloseTopup,
}) {
  if (showSaveFinalAction) {
    return (
      <div className={styles.saveActions}>
        <button
          type="button"
          className={styles.saveActions__finish}
          onClick={onFinish}
          disabled={saveBusy || saveJustDone}
        >
          {saveJustDone ? 'Завершено' : 'Завершить'}
        </button>
      </div>
    );
  }

  return topupOpen ? (
    <input
      className={styles.saveActions__input}
      type="number"
      autoFocus
      placeholder="Сумма"
      value={topupValue}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setTopupValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') submitTopup();
        if (e.key === 'Escape') onCloseTopup();
      }}
    />
  ) : (
    <button type="button" className={styles.saveActions__btn} onClick={openTopup}>
      Пополнить
    </button>
  );
}